// Kiosks list page (CHG-2061 / ITER-4159; kiosk-γ.1 worker).
//
// Thin per the v7 brief: page files ≤30 LOC, all configuration in
// @generated/screens. Today the config is hand-authored in the
// v2gen override-block layout (no kiosk.entity-hint.yaml exists yet);
// a future generator regenerates `kioskListConfig` from the hint
// without touching this file.
//
// Spec: specs/tier-05-experience/kiosk-management-list.cross-screen.yaml.
// CHG-1198 / ITER-3317 — Type column (Tap-to-Pay vs M2 badge) wired
// in the kiosk-list config + cells helper.

import { ListPage } from "../components/composition";
import { kioskListConfig } from "../generated/screens/kiosk-list";

export function Kiosks() {
  return <ListPage config={kioskListConfig} />;
}
